const template = document.createElement('template')
template.innerHTML = `
<style>

::slotted(ul) {
	display: none;
}

* {
	// box-sizing: border-box;
}

:host {
    --offset: 15px;
}

.wrapper {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: grid;
	grid-template-rows: min-content auto;
	box-sizing: border-box;
}

.parent {
	display: flex;
	flex-direction: column;
    padding-inline: 20px;
}

.list {
	overflow-y: auto;
    overflow-x: hidden;
	display: flex;
	flex-direction: column;
	padding-bottom: 1em;
    padding-inline: 20px;
}

a {
	cursor: pointer;
	transform: scale3d(1, 1, 1);
	opacity: 0;
    padding: 0.4em 0;
}

a {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    color: var(--color-white);
    text-decoration: none;
}

[part~="back-item"] {
    position: relative;
    border-bottom: 1px solid rgb(255 255 255 / 30%);
    color: var(--color-red);
    padding-bottom: 16px;
    margin-bottom: 8px;
}

[part~="back-item"] svg {
    stroke: var(--color-red);
}

[part~="back-item"]::before {
    position: absolute;
    top: 0.65em;
    left: 1px;
    width: 0.5em;
    height: 0.5em;
    rotate: 45deg;
    content: "";
    display: block;
    border: 1px solid var(--color-red);
    border-width: 0 0 2px 2px;
    opacity: 0;
    transition: all 0.2s ease-out;
}

:dir(rtl) [part~="back-item"]::before {
    rotate: 225deg;
    left: unset;
    right: 1px;
}

[part~="back-item"]:hover::before {
    opacity: 1;
}

a .svg{
    width: 9px;
    height: 9px;
    margin-top: 0.3em;
    flex-shrink: 0;
    transition: all 0.2s ease-out;
    stroke: var(--color-white);
}

a span {
    translate: 0 0;
    transition: all 0.2s ease-out;
    padding-right: var(--offset);
}

a:hover span {
    translate: var(--offset) 0;
}

:dir(rtl) a:hover span {
    translate: calc(-1 * var(--offset)) 0;
}

a:hover .svg {
    rotate: 90deg;
    stroke: var(--color-red);
}

a[part~="back-item"]:hover svg {
    rotate: 0deg;
}

.parent a.in {
	animation: back-in .2s linear forwards;
}

.parent a.out {
	animation: back-out .2s linear forwards;
}

.list a {
	animation: menu .3s calc(var(--index) * 0.05s + 0.1s) ease-out forwards;
}

@keyframes menu {
	0% {
		transform: translateY(calc(-1 * var(--offset)));
		opacity: 0;
	}

	100% {
		transform: translateY(0);
		opacity: 1;
	}
}

@keyframes back-in {
	0% {
		transform: translateX(calc(-1 * var(--offset)));
		opacity: 0;
	}

	100% {
		transform: translateX(0);
		opacity: 1;
	}
}

@keyframes back-out {
	0% {
		transform: translateX(var(--offset));
		opacity: 0;
	}

	100% {
		transform: translateX(0);
		opacity: 1;
	}
}
</style>

<div class="source"><slot></slot></div>

<div class="wrapper" part="wrapper">
	<div class="parent" part="parent"></div>
	<div class="list" part="list"></div>
</div>

<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: none;">
<symbol id="icon-link" viewBox="0 0 9 9" fill="white"><rect y="4" width="9" height="1" /><rect x="4" y="9" width="9" height="1" transform="rotate(-90 4 9)" /></symbol>
<symbol id="icon-link-back" viewBox="0 0 9 9" fill="white"><rect y="4" width="9" height="1" /></symbol>
</svg>
`

const iconForward = '<svg class="svg" aria-hidden="true" part="icon forward"><use xlink:href="#icon-link"></use></svg>'
const iconBack = '<svg class="svg" aria-hidden="true" part="icon back"><use xlink:href="#icon-link-back"></use></svg>'

customElements.define(
    'vp-menu',
    class extends HTMLElement {
        constructor() {
            super()

            this.connected = false

            this.attachShadow({ mode: 'open' })
            const clone = template.content.cloneNode(true)
            this.shadowRoot.appendChild(clone)

            this.dom = {}
            this.dom.ul = this.querySelector(':scope > ul')
            this.dom.wrapper = this.shadowRoot.querySelector('.wrapper')
            this.dom.parent = this.dom.wrapper.querySelector(':scope > .parent')
            this.dom.list = this.dom.wrapper.querySelector(':scope > .list')

            this.data = {}
            if (this.dom.ul) {
                this.root = this.parse(this.dom.ul)
            }

            // console.log(this.data, this.root)

            this.dom.wrapper.addEventListener('click', (e) => {
                const target = e.target.closest('[data-menu]')
                if (!target) return
                e.preventDefault()
                const back = target.parentNode.classList.contains('parent')
                this.set(target.dataset.menu, back)
            })
        }

        connectedCallback() {
            this.set(this.root, null)
        }

        dispatch(type, detail = null) {
            this.shadowRoot.dispatchEvent(
                new CustomEvent(type, {
                    composed: true,
                    detail,
                }),
            )
        }

        // attributeChangedCallback(name, oldValue, newValue) {
        //   if (this.connected) {
        //     // console.log(`L'attribut ${name} à changé de valeur de ${oldValue} à ${newValue}`);
        //     switch (name) {
        //       case 'gutter':
        //         const gutter = parseInt(newValue || 0, 10);
        //         this.shadowRoot.querySelector('.list').style.gap = `${parseInt(newValue || 0, 10)}px`;
        //         break;
        //       case 'controls':
        //         break;
        //     }
        //   }
        // }

        // return an array of all elements
        // elements() {
        // 	const slot = this.dom.list.querySelector(':scope > slot')
        // 	return slot.assignedNodes()
        // }

        parse(ul, parent = null) {
            const id = '_' + Math.random().toString(16).substring(2, 9)
            const o = { parent }
            o.items = []
            const lis = ul.querySelectorAll(':scope > li')
            if (lis.length > 0) {
                for (const li of lis) {
                    const a = li.querySelector(':scope > a')
                    if (a) {
                        const text = a.innerHTML
                        const link = a.getAttribute('href')
                        const target = a.getAttribute('target') || '_self'
                        const img = a.dataset?.img || null
                        const sub = li.querySelector(':scope > ul')
                        const menu = sub ? this.parse(sub, { menu: id, text, img }) : null
                        o.items.push({ text, link, target, menu })
                    }
                }
            }
            this.data[id] = o
            return id
        }

        set(id, back) {
            this.dom.parent.innerHTML = ''
            this.dom.list.innerHTML = ''
            const o = this.data[id]
            let root
            this.dispatch('change', o?.parent?.img || null)
            if (o) {
                if (o.parent) {
                    root = o.parent.menu === this.root
                    this.dom.parent.innerHTML = this.link(o.parent, null, back, root)
                }
                if (o.items.length > 0) {
                    root = id === this.root
                    for (const [key, item] of Object.entries(o.items)) {
                        this.dom.list.innerHTML += this.link(item, key, back, root)
                    }
                }
            }
        }

        link(o, key, back = false, root = false) {
            const hasMenu = !!o.menu
            const hasLink = !hasMenu && !!o.link
            const hasKey = !!key
            let before = ''
            let after = ''

            const parts = ['item']
            if (root) parts.push('is-root')
            if (hasKey) {
                parts.push('list-item')
                if (hasLink) parts.push('has-link')
                if (hasMenu) {
                    parts.push('has-menu')
                    after = iconForward
                }
            } else {
                parts.push('back-item')
                after = iconBack
            }
            const classes = ` class="${back ? 'out' : 'in'}"`

            const menu = hasMenu ? ` data-menu="${o.menu}"` : ''
            const link = !!o.link ? ` href="${o.link}"` : ''
            const target = ` target="${o.target}"`
            const part = ` part="${parts.join(' ')}"`
            const style = hasKey ? ` style="--index:${key}"` : ''

            return `<a${part}${style}${link}${target}${menu}${classes}>${before}<span>${o.text}</span>${after}</a>`
        }
    },
    { extends: 'nav' },
)
